var map = {
	"./address_image.svg": 128,
	"./animated_logo.svg": 129,
	"./blogs_image.svg": 130,
	"./cloud_infrastructure.svg": 131,
	"./codeInLogo.png": 132,
	"./codingcops.png": 133,
	"./college.png": 134,
	"./contactMail.png": 135,
	"./coursera_logo.png": 136,
	"./data_science.svg": 137,
	"./deeplearning_ai_logo.png": 138,
	"./delhivery_logo.png": 139,
	"./developerActivity.svg": 140,
	"./dock.png": 141,
	"./dsc_logo.png": 142,
	"./education.svg": 143,
	"./experience.svg": 144,
	"./feelingProud.svg": 145,
	"./freecopy_logo.png": 146,
	"./fullstack.svg": 147,
	"./gcp_logo.png": 148,
	"./github_logo.png": 149,
	"./gng.png": 150,
	"./gomoment.png": 151,
	"./googleAssistant.jpg": 152,
	"./googleAssistant.svg": 153,
	"./google_logo.png": 154,
	"./ibm_logo.png": 155,
	"./iiitk_logo.png": 156,
	"./intel_logo.jpg": 157,
	"./iu_logo.png": 158,
	"./jsFramework.svg": 159,
	"./legato_logo.png": 160,
	"./manOnTable.svg": 161,
	"./microsoft_logo.png": 162,
	"./mozilla_logo.png": 163,
	"./muffito_logo.png": 164,
	"./nextuLogo.jpg": 165,
	"./nptel_logo.png": 166,
	"./portfolio.gif": 167,
	"./profile-img.jpeg": 168,
	"./profile.jpg": 169,
	"./programmer.svg": 170,
	"./projects_image.svg": 171,
	"./pucit.png": 172,
	"./pwa.png": 173,
	"./revinate.png": 174,
	"./saayaHealthLogo.png": 175,
	"./safetymatrix.png": 176,
	"./shopify-logo.png": 177,
	"./stanford_logo.png": 178,
	"./talksCardBack.svg": 179,
	"./talksCardBackAlt.svg": 180,
	"./tiktok_logo.png": 181,
	"./ui_ux_design.svg": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;